/* global window */
const env = window.location.hostname
const prdEnv = 'transporter.azship.com.br'
const stgEnv = 'transporter.stg.azship.com.br'
const stg2Env = 'transporter.stg2.azship.com.br'
const k8sEnv = 'transporter.k8s.azship.com.br'
const devEnv = 'transporter.dev.azship.com.br'
const localEnv = 'transporter.local.azship.com.br'
const prdSSOAPI = 'https://sso.azship.com.br'
const stgSSOAPI = 'https://sso.stg.azship.com.br'
const stg2SSOAPI = 'https://sso.stg2.azship.com.br'
const k8sSSOAPI = 'https://sso.k8s.azship.com.br'
const devSSOAPI = 'https://sso.dev.azship.com.br'
// eslint-disable-next-line no-unused-vars
const localSSOAPI = 'https://sso.dev.azship.com.br'

const prdGoogleStorage =
  'https://storage.googleapis.com/prd-azship-storage-public/'
const stgGoogleStorage =
  'https://storage.googleapis.com/stg-azship-storage-public/'
const devGoogleStorage = 'https://storage.googleapis.com/azship-storage/'

const prdGoogleStoragePrivate =
  'https://storage.googleapis.com/prd-azship-storage-private/'
const stgGoogleStoragePrivate =
  'https://storage.googleapis.com/stg-azship-storage-private/'
const devGoogleStoragePrivate =
  'https://storage.googleapis.com/azship-storage-private/'

const NODE_ENV = process.env.NODE_ENV
const ONE_SIGNAL_API_KEY = process.env.ONE_SIGNAL_API_KEY
const AUTHORIZATION_KEY = process.env.AUTHORIZATION_KEY
const GOOGLE_MAPS_KEY = process.env.GOOGLE_MAPS_KEY
const MAPBOX_API_KEY = process.env.MAPBOX_API_KEY

const PRD_API = 'https://api.azship.com.br/api'
const STG_API = 'https://api.stg.azship.com.br/api'
const STG2_API = 'https://api.stg2.azship.com.br/api'
const K8S_API = 'https://api.k8s.azship.com.br/api'
const DEV_API = 'https://api.dev.azship.com.br/api'
const LOCAL_API = 'https://api.local.azship.com.br/api'

const PRD_UNSECURE_API = 'https://api.azship.com.br/unsecure/api'
const STG_UNSECURE_API = 'https://api.stg.azship.com.br/unsecure/api'
const STG2_UNSECURE_API = 'https://api.stg2.azship.com.br/unsecure/api'
const K8S_UNSECURE_API = 'https://api.k8s.azship.com.br/unsecure/api'
const DEV_UNSECURE_API = 'https://api.dev.azship.com.br/unsecure/api'
// eslint-disable-next-line no-unused-vars
const LOCAL_UNSECURE_API = 'https://api.local.azship.com.br/unsecure/api'

const PRD_API_CENTRIFUGE = 'https://centrifugo.azship.com.br/connection'
const STG_API_CENTRIFUGE = 'https://centrifugo.stg.azship.com.br/connection'
const STG2_API_CENTRIFUGE = 'https://centrifugo.stg2.azship.com.br/connection'
const K8S_API_CENTRIFUGE = 'https://centrifugo.k8s.azship.com.br/connection'
const DEV_API_CENTRIFUGE = 'https://centrifugo.dev.azship.com.br/connection'
const LOCAL_API_CENTRIFUGE =
  'https://centrifugo.local.azship.com.br/connection'

const localPrd = process.env.LOCAL_API === 'prd'
const localStg = process.env.LOCAL_API === 'stg'
const localStg2 = process.env.LOCAL_API === 'stg2'
const localK8s = process.env.LOCAL_API === 'k8s'
const localApi = process.env.LOCAL_API === 'local'

const getAPIEndpoint = () => {
  if (localPrd) return PRD_API
  if (localStg) return STG_API
  if (localStg2) return STG2_API
  if (localK8s) return K8S_API
  if (localApi) return LOCAL_API

  if (env === 'localhost') {
    return DEV_API
  }

  if (NODE_ENV === 'production' && env === prdEnv) {
    return PRD_API
  } else if (NODE_ENV === 'development' && env === devEnv) {
    return DEV_API
  } else if (env === stgEnv) {
    return STG_API
  } else if (env === stg2Env) {
    return STG2_API
  } else if (env === k8sEnv) {
    return K8S_API
  } else if (NODE_ENV === 'development' && env === localEnv) {
    return LOCAL_API
  }
  return DEV_API
}

const getCentrifugeAPIEndpoint = () => {
  if (localPrd) return PRD_API_CENTRIFUGE
  if (localStg) return STG_API_CENTRIFUGE
  if (localStg2) return STG2_API_CENTRIFUGE
  if (localK8s) return K8S_API_CENTRIFUGE
  if (localApi) return LOCAL_API_CENTRIFUGE

  if (env === 'localhost') {
    return DEV_API_CENTRIFUGE
  }

  if (NODE_ENV === 'production' && env === prdEnv) {
    return PRD_API_CENTRIFUGE
  } else if (NODE_ENV === 'development' && env === devEnv) {
    return DEV_API_CENTRIFUGE
  } else if (env === stgEnv) {
    return STG_API_CENTRIFUGE
  } else if (env === stg2Env) {
    return STG2_API_CENTRIFUGE
  } else if (env === k8sEnv) {
    return K8S_API_CENTRIFUGE
  } else if (NODE_ENV === 'development' && env === localEnv) {
    return LOCAL_API_CENTRIFUGE
  }
  return DEV_API_CENTRIFUGE
}

const getUnsecureAPIEndpoint = () => {
  if (localPrd) return PRD_UNSECURE_API
  if (localStg) return STG_UNSECURE_API
  if (localStg2) return STG2_UNSECURE_API
  if (localK8s) return K8S_UNSECURE_API
  if (localApi) return DEV_UNSECURE_API

  if (NODE_ENV === 'production' && env === prdEnv) {
    return PRD_UNSECURE_API
  } else if (env === stgEnv) {
    return STG_UNSECURE_API
  } else if (env === stg2Env) {
    return STG2_UNSECURE_API
  } else if (env === k8sEnv) {
    return K8S_UNSECURE_API
  } else if (NODE_ENV === 'development' && env === devEnv) {
    return DEV_UNSECURE_API
  } else if (NODE_ENV === 'development' && env === localEnv) {
    return DEV_UNSECURE_API
  }
  return DEV_UNSECURE_API
}

const getSSOEndpoint = () => {
  if (localPrd) return prdSSOAPI
  if (localStg) return stgSSOAPI
  if (localStg2) return stg2SSOAPI
  if (localK8s) return k8sSSOAPI
  if (localApi) return stgSSOAPI

  if (env === 'localhost') {
    return devSSOAPI
  }

  if (NODE_ENV === 'production' && env === prdEnv) {
    return prdSSOAPI
  } else if (NODE_ENV === 'development' && env === devEnv) {
    return devSSOAPI
  } else if (env === stgEnv) {
    return stgSSOAPI
  } else if (env === stg2Env) {
    return stg2SSOAPI
  } else if (env === k8sEnv) {
    return k8sSSOAPI
  } else if (NODE_ENV === 'development' && env === localEnv) {
    return stgSSOAPI
  }
  return devSSOAPI
}

const getLocalHostname = () => {
  if (localPrd) return `https://${prdEnv}/`
  if (localStg) return `https://${stgEnv}/`
  if (localStg2) return `https://${stg2Env}/`
  if (localK8s) return `https://${k8sEnv}/`
  if (localApi) return `https://${localEnv}/`

  if (env === 'localhost') {
    return 'http://localhost:4000'
  }
  if (NODE_ENV === 'production' && env === prdEnv) {
    return `https://${prdEnv}/`
  } else if (NODE_ENV === 'development' && env === devEnv) {
    return `https://${devEnv}/`
  } else if (env === stgEnv) {
    return `https://${stgEnv}/`
  } else if (env === stg2Env) {
    return `https://${stg2Env}/`
  } else if (env === k8sEnv) {
    return `https://${k8sEnv}/`
  } else if (NODE_ENV === 'development' && env === localEnv) {
    return `https://${localEnv}/`
  }
  return `https://${devEnv}/`
}

const getGoogleHostname = () => {
  if (localPrd) return prdGoogleStorage
  if (localStg) return stgGoogleStorage
  if (localStg2) return stgGoogleStorage
  if (localK8s) return devGoogleStorage
  if (localApi) return devGoogleStorage

  if (env === 'localhost') {
    return devGoogleStorage
  }
  if (NODE_ENV === 'production' && env === prdEnv) {
    return prdGoogleStorage
  } else if (env === stgEnv) {
    return stgGoogleStorage
  } else if (env === stg2Env) {
    return stgGoogleStorage
  } else if (env === k8sEnv) {
    return devGoogleStorage
  } else if (NODE_ENV === 'development' && env === devEnv) {
    return devGoogleStorage
  }
  return devGoogleStorage
  // return prdGoogleStorage
}
const getGooglePrivateHostname = () => {
  if (localPrd) return prdGoogleStoragePrivate
  if (localStg) return stgGoogleStoragePrivate
  if (localStg2) return stgGoogleStoragePrivate
  if (localK8s) return devGoogleStoragePrivate
  if (localApi) return devGoogleStoragePrivate

  if (env === 'localhost') {
    return devGoogleStoragePrivate
  }
  if (NODE_ENV === 'production' && env === prdEnv) {
    return prdGoogleStoragePrivate
  } else if (env === stgEnv) {
    return stgGoogleStoragePrivate
  } else if (env === stg2Env) {
    return stgGoogleStoragePrivate
  } else if (env === k8sEnv) {
    return devGoogleStoragePrivate
  } else if (NODE_ENV === 'development' && env === devEnv) {
    return devGoogleStoragePrivate
  }
  return devGoogleStoragePrivate
}

const GOOGLE_STORAGE_ENDPOINT = getGoogleHostname()
const GOOGLE_STORAGE_PRIVATE_ENDPOINT = getGooglePrivateHostname()

const IS_PRD = NODE_ENV === 'production' && env === prdEnv
// const IS_PRD = true

export {
  getAPIEndpoint,
  getCentrifugeAPIEndpoint,
  getUnsecureAPIEndpoint,
  getSSOEndpoint,
  getLocalHostname,
  ONE_SIGNAL_API_KEY,
  AUTHORIZATION_KEY,
  GOOGLE_MAPS_KEY,
  MAPBOX_API_KEY,
  GOOGLE_STORAGE_ENDPOINT,
  GOOGLE_STORAGE_PRIVATE_ENDPOINT,
  IS_PRD,
}
